import React from "react";

export default function CTA() {
  return (
    <>
      {/* ⭐ INLINE CLEAN PREMIUM CSS */}
      <style>{`
        .cta-wrapper {
          background: linear-gradient(135deg, #e8f0ff, #ffffff);
          padding: 90px 0;
          display: flex;
          align-items: center;
        }

        .cta-box {
          background: #ffffff;
          padding: 45px 35px;
          border-radius: 18px;
          max-width: 700px;
          margin: 0 auto;
          text-align: center;
          box-shadow: 0px 10px 35px rgba(0,0,0,0.08);
          border: 1px solid rgba(0,0,0,0.05);
          animation: fadeUp 1s ease forwards;
          opacity: 0;
        }

        .cta-title {
          font-weight: 800;
          font-size: 32px;
          color: #002a71;
        }

        .cta-sub {
          font-size: 18px;
          margin-top: 10px;
          color: #555;
        }

        .cta-contact {
          margin-top: 25px;
          display: flex;
          justify-content: center;
          gap: 25px;
          flex-wrap: wrap;
        }

        .cta-info {
          background: #f8faff;
          padding: 12px 18px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          gap: 10px;
          border: 1px solid #dce6ff;
          font-size: 16px;
          color: #003b99;
          font-weight: 600;
          transition: 0.3s;
        }

        .cta-info:hover {
          background: #eaf1ff;
          border-color: #005eff;
        }

        .cta-info i {
          font-size: 20px;
          color: #005eff;
        }

        .cta-btn {
          margin-top: 30px;
          padding: 12px 28px;
          font-size: 18px;
          border-radius: 10px;
          background: #005eff;
          color: white;
          border: none;
          font-weight: 600;
          transition: 0.3s ease;
        }

        .cta-btn:hover {
          background: #0040c9;
          transform: translateY(-3px);
          box-shadow: 0px 8px 20px rgba(0,64,201,0.3);
        }

        @keyframes fadeUp {
          0% { opacity: 0; transform: translateY(20px); }
          100% { opacity: 1; transform: translateY(0); }
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .cta-title {
            font-size: 26px;
          }
          .cta-sub {
            font-size: 16px;
          }
          .cta-info {
            font-size: 15px;
          }
        }
      `}</style>

      {/* ⭐ CTA SECTION */}
      <section className="cta-wrapper">
        <div className="cta-box">

          <h2 className="cta-title">Ready to Ship with Confidence?</h2>

          <p className="cta-sub">
            Get instant pricing and start your shipment with trusted logistics experts.
          </p>

          {/* CONTACT OPTIONS */}
          <div className="cta-contact">
            <div className="cta-info">
              <i className="bi bi-telephone-fill"></i>
              <a href="tel:4805200274" className="text-decoration-none text-dark">
                (480) 520-0274
            </a>
            </div>

            <div className="cta-info">
              <i className="bi bi-envelope-fill"></i>
              <a href="mailto:info@swiftship.us" className="text-decoration-none text-dark">
                info@swiftship.us
              </a>
            </div>
          </div>

          <button className="cta-btn">
            Get A Quote →
          </button>

        </div>
      </section>
    </>
  );
}
